import { Card, Dropdown, Menu, Modal, Table } from "antd";
import React, { useState, useEffect, useCallback, useRef } from "react";
import { Layout, Button, Row, Form, Input, Col, Select, Collapse, theme, notification, Tag } from "antd";
import { useNavigate, Link } from "react-router-dom";

import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
import TenantsApi from "../../common/Apis/TenantApi";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import QuestionnairesApi from "../../common/Apis/QuestionnairesApi";
import { CheckCircleTwoTone, CloseCircleTwoTone, MinusCircleTwoTone, PlusCircleTwoTone } from "@ant-design/icons";
import CreateTenantModel from "./CreateTenantModel";
import UpdateTenantModal from "./UpdateTenantModel";
import CreatePaymentModal from "../Payments/CreatePaymentModel";
import DeleteTenantConfirmModal from "../Tenants/DeleteTenantConfirmModal";
import { createDefaultTenant } from "../../../models/Tenant/TenantDTO";
import UpdateTenantRateModal from "./UpdateTenantRateModel";
import AddAdminUserTenant from "../CreateUser/AddAdminUserTenant";
import AddTenantRateModal from "./AddTenantRateModal";
import InvoiceModal from "../Payments/InvoiceModel";
import CurrencySetModal from "./CurrencySetModal";
import Pagination from "../../common/Pagination/Pagination"; 
import "../../common/Pagination/Pagination.css"; 


const { confirm } = Modal;

const Tenants = () => {
  const navigate = useNavigate();
  const { Content } = Layout;
  const { Panel } = Collapse;
  const [Tenants, setTenants] = React.useState([]);
  const [PaginatePage, setPaginatePage] = useState(0);
  const [PaginatetotalPages, settotalPages] = useState(null);
  const [PaginateLimit, setPaginateLimit] = useState(10);
  const [formPaginate] = Form.useForm();
  const { useToken } = theme;
  const { token } = useToken();
  const [roleCode, setRoleCode] = useState("");
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const [PaymentReceiveModelVisible, setPaymentReceiveModelVisible] = useState(false);
  const [UpdateTenantRateModelVisible, setUpdateTenantRateModelVisible] = useState(false);
  const [selectedTenantId, setSelectedTenantId] = useState(null);  // <-- added selectedTenantId
  const [selectedTenant, setSelectedTenant] = useState(null);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [tenantToDelete, setTenantToDelete] = useState(null);
  const [apiError, setApiError] = useState(null);
  const [updateTenantModelVisible, setUpdateTenantModelVisible] = useState(false);
  const [editingTenant, setEditingTenant] = useState(null);
  const [tenantAdminModelVisible, setTenantAdminAddModalVidibble] = useState(false);
  const [tenantSubscriptionModelVisible, setTenantSubscriptionModelVisible] = useState(false);
  const [isInvoiceModelOpen, setIsInvoiceModelOpen] = useState(false);
  const [tenantDetailsModalVisible, setTenantDetailsModalVisible] = useState(false);
  const [selectedTenantDetails, setSelectedTenantDetails] = useState(null);
  const [tenantCurrencyModalVisible, setTenantCurrencyModalVisible] = useState(false);
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    const userDetailsString = localStorage.getItem("decodedToken");
    if (userDetailsString) {
      const userDetails = JSON.parse(userDetailsString);
      const firstRoleDTO = userDetails.roles && userDetails.roles[0];
      if (firstRoleDTO) {
        setRoleCode(firstRoleDTO);
      }
    }
  }, []);

  const showDeleteModal = (tenant) => {
    setTenantToDelete(tenant);
    setDeleteModalVisible(true);
  };

  const showInvoiceModal = (tenant) => {
    setSelectedTenant(tenant);
    setIsInvoiceModelOpen(true);
  };

  const handleUpdateTenant = (values) => {
    setEditingTenant(values);
    setUpdateTenantModelVisible(true);
  };

  const closeUpdateTenant = () => {
    getTenants();
    setEditingTenant(null);
    setUpdateTenantModelVisible(false);
  };

  const showTenantAdminUserAddModal = (tenant) => {
    // console.log("tenant id " + tenant?.id);
    setSelectedTenant(tenant);
    setTenantAdminAddModalVidibble(true);
  }

  const showSubscriptionAddModal = (tenant) => {
    console.log("tenant id " + tenant?.id);
    setSelectedTenant(tenant);
    setTenantSubscriptionModelVisible(true);
  }

  const showCurrencyChangeModal = (tenant) => {
    console.log("tenant id " + tenant?.id);
    setSelectedTenant(tenant);
    setTenantCurrencyModalVisible(true);
  }

  const showDeactivateConfirm = (tenant) => {
    confirm({
      title: `Are you sure you want to deactivate tenant "${tenant.tenantName}"?`,
      content: "This action can be undone.",
      okText: "Yes, Deactivate",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        const payload = createDefaultTenant({
          id: tenant.id,
          tenantCode: tenant.tenantCode,
          tenantName: tenant.tenantName,
          enabled: false,
          multitenancy: tenant.multitenancy
        });

        TenantsApi.Edittenants(tenant?.id, payload)
          .then(() => {
            getTenants();
            notification.open({
              message: (
                <span style={{ fontWeight: "bold" }}>
                  Tenant / Customer deactivated successfully!
                </span>
              ),
              closeIcon: false,
              duration: 3,
              style: {
                backgroundColor: "#b3ffb3",
                color: "green",
              },
            });
          })
          .catch((error) => {
            console.error("Error deactivating tenant:", error);

            notification.open({
              message: (
                <span style={{ fontWeight: "bold" }}>
                  Failed to deactivate tenant
                </span>
              ),
              description: error?.response?.data?.message || "An unexpected error occurred.",
              closeIcon: false,
              duration: 4,
              style: {
                backgroundColor: "#ffcccc",
                color: "red",
              },
            });
          });

        console.log("Deactivating tenant:", tenant.id);
      },
      onCancel() {
        console.log("Deactivation cancelled");
      },
    });
  };

  const showActivateConfirm = (tenant) => {
    confirm({
      title: `Are you sure you want to activate tenant "${tenant.tenantName}"?`,
      content: "This action can be undone.",
      okText: "Yes, Activate",
      okType: "primary",
      cancelText: "Cancel",
      onOk() {
        const payload = createDefaultTenant({
          id: tenant.id,
          tenantCode: tenant.tenantCode,
          tenantName: tenant.tenantName,
          enabled: true,
          multitenancy: tenant.multitenancy
        });

        TenantsApi.Edittenants(tenant?.id, payload)
          .then(() => {
            getTenants();
            notification.open({
              message: (
                <span style={{ fontWeight: "bold" }}>
                  Tenant / Customer activated successfully!
                </span>
              ),
              closeIcon: false,
              duration: 3,
              style: {
                backgroundColor: "#b3ffb3",
                color: "green",
              },
            });
          })
          .catch((error) => {
            console.error("Error deactivating tenant:", error);

            notification.open({
              message: (
                <span style={{ fontWeight: "bold" }}>
                  Failed to deactivate tenant
                </span>
              ),
              description: error?.response?.data?.message || "An unexpected error occurred.",
              closeIcon: false,
              duration: 4,
              style: {
                backgroundColor: "#ffcccc",
                color: "red",
              },
            });
          });

        console.log("Deactivating tenant:", tenant.id);
      },
      onCancel() {
        console.log("Deactivation cancelled");
      },
    });
  };

  const handleDelete = (tenantId) => {
    TenantsApi.DeleteTenant(tenantId)
      .then((res) => {
        setApiError(null);
        console.log("Tenant deleted successfully:", res);
        setDeleteModalVisible(false);
        setTenantToDelete(null);
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Tenant deleted successfully!</span>,
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        // Optionally refresh tenant list here
        getTenants(); // call your existing fetch tenants function
      })
      .catch((err) => {
        console.error("Error deleting tenant:", err);
        setApiError(
          err?.apiError?.message ||
          err?.message ||
          "Tenant deletion failed. Please try again."
        );
        // Optionally show error notification here
      });
  };

  const handleCancelDelete = () => {
    setDeleteModalVisible(false);
    setTenantToDelete(null);
  };

  formPaginate.setFieldsValue({
    paginate: PaginateLimit,
  });
  const handlesetPaginateLimit = (value) => {
    setPaginateLimit(value);
    setCurrentPage(1);
    formPaginate.setFieldsValue({
      paginate: value,
    });
    TenantsApi.tenantsList(0, value)
      .then((response) => {
        settotalPages(response.totalPages);
        setTenants(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  };
  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    let pageNew = page - 1;
    TenantsApi.tenantsList(pageNew, PaginateLimit)
      .then((response) => {
        setPaginatePage(pageNew);
        settotalPages(response.totalPages);
        setTenants(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getTenants = useCallback(() => {
    TenantsApi.tenantsList(PaginatePage, PaginateLimit)
      .then((response) => {
        settotalPages(response.totalPages);
        setTenants(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  }, [PaginatePage, PaginateLimit]);

  useEffect(() => {
    getTenants();
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, [getTenants]);

  const [pageSize, setPageSize] = useState(10);

  const formRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleRemovefilterTenant = (FilterTenantIndex) => {
    const newfilterTenant = [...filterTenant];
    newfilterTenant.splice(FilterTenantIndex, 1);
    setFilterTenants(newfilterTenant);
    if (FilterTenantIndex === 0) {
      getTenants();
    }
  };
  const handleClear = () => {
    getTenants();
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    setFilterTenants([
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };

  const [filterTenant, setFilterTenants] = useState([
    {
      title: "",
      answerType: "",
      name: "",
    },
  ]);

  const handleAddfilterTenants = () => {
    setFilterTenants([
      ...filterTenant,
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };

  const handleSubmit = (data) => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    let singleLineString = filterTenant
      .map((obj) => {
        if (obj.answerType === "%") {
          return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
        } else if (obj.answerType === "=") {
          return `${obj.title}${obj.answerType}${obj.name}`;
        } else {
          return `${obj.title}=BETWEEN${createDateTimestamp(
            obj.answerType
          )}AND${createDateTimestamp(obj.name)}`;
        }
      })
      .join("&");
    console.log(singleLineString);

    let filderData = window.btoa("componentCode=TENANT&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
);
    QuestionnairesApi.FilterQuestionsetNext(filderData, 0, PaginateLimit)
      .then((response) => {
        setTenants(response.payloadDto);
      })
      .catch((err) => { });
  };
  const createDateTimestamp = (Cdate) => {
    const date = new Date(Cdate);
    const unixTime = Math.floor(date.getTime());
    return unixTime;
  };
  const handleChangeTitle = (filterTenantIndex, value) => {
    const newfilterTenant = [...filterTenant];
    newfilterTenant[filterTenantIndex].title = value;
    setFilterTenants(newfilterTenant);
  };
  const handleChangeAnswertype = (filterTenantIndex, value) => {
    const newfilterTenant = [...filterTenant];
    newfilterTenant[filterTenantIndex].answerType = value;
    setFilterTenants(newfilterTenant);
  };

  const handleChangename = (filterTenantIndex, value) => {
    const newfilterTenant = [...filterTenant];
    newfilterTenant[filterTenantIndex].name = value;
    setFilterTenants(newfilterTenant);
  };

  const openPaymentReceiveModal = (tenantId, tenant) => {
    setSelectedTenantId(tenantId);
    setSelectedTenant(tenant);
    setPaymentReceiveModelVisible(true);
  };

  const openUpdateTenantRateModal = (tenantId, tenant) => {
    setSelectedTenantId(tenantId);
    setSelectedTenant(tenant);
    setUpdateTenantRateModelVisible(true);
  };

  const closePaymentReceiveModal = () => {
    getTenants();
    setPaymentReceiveModelVisible(false);
    setSelectedTenant(null);
  };

  const closeUpdateTenantRateModal = () => {
    getTenants();
    setUpdateTenantRateModelVisible(false);
    setSelectedTenant(null);
  };

  const handlePaymentSubmit = ({ tenantId, paymentTerm, rate }) => {
    console.log("Payment received for tenant:", tenantId, paymentTerm, rate);
    // TODO: Add your API call or logic here to process the payment
    closePaymentReceiveModal();
  };

  const paginatedData = Tenants;

  //   const renderCards = () => {
  //   return paginatedData
  //     .filter(item => item.tenantCode !== "iva")
  //     .map((item) => {
  //       const menu = (
  //         <Menu>
  //           <Menu.Item key="users">
  //             <Link to={`/tenants/users?id=${item.id}`}>Users</Link>
  //           </Menu.Item>
  //           <Menu.Item key="addAdmin">
  //             <Button type="text" onClick={() => showTenantAdminUserAddModal(item)}>
  //               Add an admin
  //             </Button>
  //           </Menu.Item>
  //           {item.monthlyRate === 0.00 && item.annualRate === 0.00 && (
  //             <Menu.Item key="addSubscription">
  //               <Button type="text" onClick={() => showSubscriptionAddModal(item)}>
  //                 Add a subscription plan
  //               </Button>
  //             </Menu.Item>
  //           )}
  //           {item.tenantCode !== "iva" && (
  //             <Menu.Item key="shops">
  //               <Button type="text" onClick={() => navigate(`/tenants/sub-tenants?id=${item.id}`)}>
  //                 Shops / Stores
  //               </Button>
  //             </Menu.Item>
  //           )}
  //           <Menu.Item key="renew">
  //             <Button type="text" onClick={() => openPaymentReceiveModal(item.id, item)}>
  //               Renew Subscription
  //             </Button>
  //           </Menu.Item>
  //           {item.enabled
  //             ? <Menu.Item key="deactivate">
  //                 <Button type="text" onClick={() => showDeactivateConfirm(item)}>Deactivate</Button>
  //               </Menu.Item>
  //             : <Menu.Item key="activate">
  //                 <Button type="text" onClick={() => showActivateConfirm(item)}>Activate</Button>
  //               </Menu.Item>
  //           }
  //           <Menu.Item key="editPlan">
  //             <Button type="text" onClick={() => openUpdateTenantRateModal(item.id, item)}>
  //               Edit subscription plan
  //             </Button>
  //           </Menu.Item>
  //           <Menu.Item key="editTenant">
  //             <Button type="text" onClick={() => handleUpdateTenant(item)}>
  //               Edit tenant details
  //             </Button>
  //           </Menu.Item>
  //           {!item.enabled && (
  //             <Menu.Item key="delete">
  //               <Button type="text" danger onClick={() => showDeleteModal(item)}>
  //                 Delete
  //               </Button>
  //             </Menu.Item>
  //           )}
  //           <Menu.Item key="audit">
  //             <Button type="text" onClick={() => navigate(`/tenant/audit-trail?id=${item.id}`)}>
  //               Audit Trail
  //             </Button>
  //           </Menu.Item>
  //           <Menu.Item key="invoice">
  //             <Button type="text" onClick={() => showInvoiceModal(item)}>
  //               Generate an invoice
  //             </Button>
  //           </Menu.Item>
  //         </Menu>
  //       );

  //       const InfoRow = ({ label, children }) => (
  //         <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
  //           <span style={{ fontWeight: 500 }}>{label}</span>
  //           <span>{children}</span>
  //         </div>
  //       );

  //       return (
  //         <Card
  //           key={item.id}
  //           size="small"
  //           style={{
  //             marginBottom: "12px",
  //             background: item.enabled === false ? "#ffcccc" : "white"
  //           }}
  //           title={`${item.tenantName} (${item.tenantCode})`}
  //           extra={
  //             <Dropdown overlay={menu} trigger={['click']}>
  //               <Button type="default" size="small">Actions</Button>
  //             </Dropdown>
  //           }
  //         >
  //           <InfoRow label="Registered Date:">
  //             {new Date(item.createdDate).toLocaleDateString("en-US", {
  //               year: "numeric", month: "short", day: "numeric"
  //             })}
  //           </InfoRow>

  //           <InfoRow label="Billing Cycle:">
  //             {item.paymentStatus === "TRIAL" && <Tag color="blue" style={{ margin: 0 }}>TRIAL</Tag>}
  //             {item.paymentStatus === "PAID" && <Tag color="green" style={{ margin: 0 }}>PAID</Tag>}
  //             {item.paymentStatus === "OVERDUE" && <Tag color="cyan" style={{ margin: 0 }}>OVERDUE</Tag>}
  //             {item.paymentStatus === "WARNING" && <Tag color="orange" style={{ margin: 0 }}>WARNING</Tag>}
  //             {item.paymentStatus === "SUSPENDED" && <Tag color="red" style={{ margin: 0 }}>SUSPENDED</Tag>}
  //           </InfoRow>

  //           <InfoRow label="Subscription Status:">
  //             {item.enabled ? <Tag color="green" style={{ margin: 0 }}>Active</Tag> : <Tag color="red" style={{ margin: 0 }}>Inactive</Tag>}
  //           </InfoRow>

  //           <InfoRow label="Has Multiple Shops:">
  //             {item.multitenancy
  //               ? <CheckCircleTwoTone twoToneColor="#52c41a" />
  //               : <CloseCircleTwoTone twoToneColor="#ff4d4f" />}
  //           </InfoRow>
  //         </Card>
  //       );
  //     });
  // };

  const showTenantDetails = (tenant) => {
    setSelectedTenantDetails(tenant);
    setTenantDetailsModalVisible(true);
  };

  const closeTenantDetailsModal = () => {
    setTenantDetailsModalVisible(false);
    setSelectedTenantDetails(null);
  };

  const getTenantDetailsData = (tenant) => {
    if (!tenant) return [];

    const details = [
      { field: 'Tenant Code', value: tenant.tenantCode || 'N/A' },
      { field: 'Tenant Name', value: tenant.tenantName || 'N/A' },
      {
        field: 'Registered Date', value: new Date(tenant.createdDate).toLocaleDateString("en-US", {
          year: "numeric", month: "long", day: "numeric"
        })
      },
      { field: 'Subscription Status', value: tenant.enabled ? 'Active' : 'Inactive' },
      { field: 'Billing Cycle Status', value: tenant.paymentStatus || 'N/A' },
      { field: 'Has Multiple Shops', value: tenant.multitenancy ? 'Yes' : 'No' },
      { field: 'Monthly Rate', value: `$${tenant.monthlyRate || '0.00'}` },
      { field: 'Annual Rate', value: `$${tenant.annualRate || '0.00'}` },
      { field: 'Contact Person', value: tenant.contactPerson || 'N/A' },
      { field: 'Contact Email', value: tenant.contactEmail || 'N/A' },
      { field: 'Contact Phone', value: tenant.contactPhone || 'N/A' },
      { field: 'Contact Address', value: tenant.contactAddress || 'N/A' },
    ];

    return details;
  };


  const renderTableRows = () => {


    return paginatedData
      .filter(item => item.tenantCode !== "iva")
      .map((item) => (
        <tr key={item.id} className="text-center" style={{
          background: item.enabled === false ? "#ffcccc" : "transparent", padding: '0px'
        }}>
          <td style={{ display: "flex" }}><Tag color="orange" title={"tenant count : " + item.subTenantCount}>{item.subTenantCount}</Tag>&nbsp;{item.tenantCode}</td>
          <td>{item.tenantName}</td>
          <td>
            {new Date(item.createdDate).toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </td>
          <td style={{ textAlign: "center" }}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              {item.paymentStatus === "TRIAL" && item.tenantCode != "iva" && <Tag color="blue">TRIAL</Tag>}
              {item.paymentStatus === "PAID" && item.tenantCode != "iva" && <Tag color="blue">PAID</Tag>}
              {item.paymentStatus === "OVERDUE" && item.tenantCode != "iva" && <Tag color="cyan">OVERDUE</Tag>}
              {item.paymentStatus === "WARNING" && item.tenantCode != "iva" && <Tag color="orange">WARNING</Tag>}
              {item.paymentStatus === "SUSPENDED" && item.tenantCode != "iva" && <Tag color="red">SUSPENDED</Tag>}
            </div>
          </td>
          <td style={{ textAlign: "center" }}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              {item.multitenancy === false && item.tenantCode != "iva" && <CloseCircleTwoTone twoToneColor="#ff4d4f" />}
              {item.multitenancy === true && item.tenantCode != "iva" && <CheckCircleTwoTone twoToneColor="#52c41a" />}
            </div>
          </td>
          <td>
            <div
              className="d-flex justify-content-center align-items-center"
            >
              <div className="dropdown">
                <Button
                  type="default"
                  className="dropdown-toggle"
                  id={`actionMenu-${item.id}`}
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Actions
                </Button>
                <ul
                  className="dropdown-menu"
                  aria-labelledby={`actionMenu-${item.id}`}
                >
                  <li>
                    {/* <Link
                      className="dropdown-item"
                      to={`/tenants/users?id=${item.id}`}
                    >
                      Users
                    </Link> */}
                    <li>
                      <Button
                        type="button"
                        className="dropdown-item"
                        onClick={() => showTenantDetails(item)}
                      >
                        See Details
                      </Button>
                    </li>
                    <Button
                      type="button"
                      className="dropdown-item"
                      onClick={() => {
                        navigate("/tenants/users?id=" + item.id);
                      }}
                    >
                      Users
                    </Button>
                  </li>
                  <li>
                    <Button
                      type="button"
                      className="dropdown-item"
                      onClick={() => showTenantAdminUserAddModal(item)}
                    >
                      Add an admin
                    </Button>
                  </li>
                  {item.monthlyRate === 0.00 && item.annualRate === 0.00 && <li>
                    <Button
                      type="button"
                      className="dropdown-item"
                      onClick={() => showSubscriptionAddModal(item)}
                    >
                      Add a subscription plan
                    </Button>
                  </li>}
                  <li>
                    <Button
                      type="button"
                      className="dropdown-item"
                      onClick={() => showCurrencyChangeModal(item)}
                    >
                      Change Currency
                    </Button>
                  </li>
                  {item.tenantCode !== "iva" && <li>
                    <Button
                      type="button"
                      className="dropdown-item"
                      onClick={() => {
                        navigate("/tenants/sub-tenants?id=" + item.id);
                      }}
                    >
                      Shops / Stores
                    </Button>
                  </li>}
                  {item.tenantCode !== "iva" && <li>
                    <Button
                      type="button"
                      className="dropdown-item"
                      onClick={() => openPaymentReceiveModal(item.id, item)}

                    >
                      Renew Subscription
                    </Button>
                  </li>}
                  {item.tenantCode !== "iva" && item.enabled !== false && <li>
                    <Button
                      type="button"
                      className="dropdown-item"
                      onClick={() => showDeactivateConfirm(item)}
                    >
                      Deactivate
                    </Button>
                  </li>}
                  {item.tenantCode !== "iva" && item.enabled === false && <li>
                    <Button
                      type="button"
                      className="dropdown-item"
                      onClick={() => showActivateConfirm(item)}
                    >
                      Activate
                    </Button>
                  </li>}
                  {item.tenantCode !== "iva" && <li>
                    <Button
                      type="button"
                      className="dropdown-item"
                      onClick={() => openUpdateTenantRateModal(item.id, item)}

                    >
                      Edit subscription plan
                    </Button>
                  </li>}
                  <Button
                    type="button"
                    className="dropdown-item"
                    onClick={() => handleUpdateTenant(item)}
                  >
                    Edit tenant details
                  </Button>
                  {item.tenantCode !== "iva" && item.enabled === false && <li>
                    <Button
                      type="button"
                      className="dropdown-item"
                      onClick={() => showDeleteModal(item)}
                    >
                      Delete
                    </Button>
                  </li>}
                  <Button
                    type="button"
                    className="dropdown-item"
                    onClick={() => navigate("/tenant/audit-trail?id=" + item.id)}
                  >
                    Audit Trail
                  </Button>
                  {item.paymentStatus === "PAID" && <li>
                    <Button
                      type="button"
                      className="dropdown-item"
                      onClick={() => showInvoiceModal(item)}
                    >
                      Payment Receipt
                    </Button>
                  </li>}
                </ul>
              </div>
            </div>
          </td>
        </tr>
      ));
  };


  const [tenantCreateForm] = Form.useForm();
  const [modalVisible, setModalVisible] = useState(false);

  const handleCreate = (values) => {
    console.log("Creating tenant:", values);
    // Call your API here
    setModalVisible(false);
    tenantCreateForm.resetFields();
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />

      <Layout>
        <TopHeader />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}

        <div
          style={{
            padding: "20px",
            paddingBottom: "5px",
          }}
        >
          <Form
            ref={formRef}
            name="nest-messages"
            layout="vertical"
            className="FormClass FilterForm"
            onFinish={handleSubmit}
          >
            <>
              <Collapse>
                <Panel
                  header={
                    <h5 className="mb-0">
                      <b>Filter</b>
                    </h5>
                  }
                  key="1"
                >
                  {filterTenant.map((input, filterTenantIndex) => (
                    <div key={filterTenantIndex}>
                      <Row gutter={12}>
                        <Col span={5}>
                          <Form.Item
                            name={`title${filterTenantIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please Select",
                              },
                            ]}
                          >
                            <Select
                              className="control-Select"
                              placeholder="Filter By"
                              value={input.title}
                              onChange={(value) =>
                                handleChangeTitle(filterTenantIndex, value)
                              }
                              options={[
                                { value: "tenantCode", label: "Code" },
                                {
                                  value: "tenantName",
                                  label: "Name",
                                },
                                {
                                  value: "createdDate",
                                  label: "Registered Date",
                                },
                              ]}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={4}>
                          {filterTenant[filterTenantIndex].title ===
                            "createdDate" ? (
                            <>
                              <Form.Item
                                name={`nameto${filterTenantIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select Start Date.",
                                  },
                                ]}
                              >
                                <Input
                                  type="date"
                                  placeholder="Filter By"
                                  onChange={(e) =>
                                    handleChangeAnswertype(
                                      filterTenantIndex,
                                      e.target.value
                                    )
                                  }
                                  className="control-input"
                                />
                              </Form.Item>
                            </>
                          ) : (
                            <>
                              <Form.Item
                                name={`type${filterTenantIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select type.",
                                  },
                                ]}
                              >
                                <Select
                                  className="control-Select mb-1"
                                  placeholder="Condition"
                                  onChange={(value) =>
                                    handleChangeAnswertype(
                                      filterTenantIndex,
                                      value
                                    )
                                  }
                                  options={[
                                    { value: "%", label: "Matches with" },
                                    {
                                      value: "=",
                                      label: "Equals to",
                                    },
                                  ]}
                                />
                              </Form.Item>
                            </>
                          )}
                        </Col>
                        <Col span={5}>
                          {filterTenant[filterTenantIndex].title ===
                            "createdDate" ? (
                            <>
                              <Form.Item
                                name={`name${filterTenantIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select End Date.",
                                  },
                                ]}
                              >
                                <Input
                                  type="date"
                                  onChange={(e) =>
                                    handleChangename(
                                      filterTenantIndex,
                                      e.target.value
                                    )
                                  }
                                  placeholder="Text"
                                  className="control-input"
                                />
                              </Form.Item>
                            </>
                          ) : (
                            <>
                              <Form.Item
                                name={`name${filterTenantIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter Text.",
                                  },
                                ]}
                              >
                                <Input
                                  type="text"
                                  onChange={(e) =>
                                    handleChangename(
                                      filterTenantIndex,
                                      e.target.value
                                    )
                                  }
                                  placeholder="Text"
                                  className="control-input"
                                />
                              </Form.Item>
                            </>
                          )}
                        </Col>

                        <Col span={8}>
                          <Form.Item className="text-lable">
                            {filterTenantIndex === 0 ? (
                              <>
                                <Row gutter={23} className="mb-3">
                                  <Col span={2} className="mx-0">
                                    <Form.Item className="text-lable">
                                      <PlusCircleTwoTone
                                        onClick={handleAddfilterTenants}
                                      />
                                    </Form.Item>
                                  </Col>

                                  <Col span={10}>
                                    <Button
                                      type="primary"
                                      htmlType="submit"
                                      className="btn btn-primary btn-save table-action icon-center "
                                    >
                                      Filter
                                    </Button>
                                  </Col>
                                  <Col span={10}>
                                    <Button
                                      type="reset"
                                      htmlType="reset"
                                      onClick={() => handleClear()}
                                      style={{ color: "#0b5ed7" }}
                                      className="btn btn-primary btn-back table-action icon-center"
                                    >
                                      Clear
                                    </Button>
                                  </Col>
                                </Row>
                              </>
                            ) : (
                              <>
                                {" "}
                                <MinusCircleTwoTone
                                  onClick={() =>
                                    handleRemovefilterTenant(filterTenantIndex)
                                  }
                                />
                              </>
                            )}
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </Panel>
              </Collapse>
            </>
          </Form>
        </div>
        <Content
          className="form-content nav-content"
          style={{
            margin: "14px 16px 0",
            padding: "30px",
            background: "white",
          }}
        >
          {roleCode === "SUPER_ADMIN" && (
            <div>
              <Button type="primary" style={{ padding: '5px 24px', fontSize: '18px' }} onClick={() => setModalVisible(true)}>
                Add New Tenant / Customer
              </Button>

              <CreateTenantModel
                visible={modalVisible}
                onCancel={() => setModalVisible(false)}
                onSubmit={handleCreate}
                form={tenantCreateForm}
                onTenantCreated={getTenants}
              />
              <AddAdminUserTenant
                open={tenantAdminModelVisible}
                onClose={() => setTenantAdminAddModalVidibble(false)}
                tenantId={selectedTenant?.id}
              />
              <UpdateTenantModal
                visible={updateTenantModelVisible}
                onCancel={() => closeUpdateTenant()}
                onOk={handleUpdateTenant}
                initialValues={{
                  id: editingTenant?.id,
                  tenantCode: editingTenant?.tenantCode,
                  tenantName: editingTenant?.tenantName,
                  multitenancy: editingTenant?.multitenancy ?? false,
                  contactPerson: editingTenant?.contactPerson,
                  contactEmail: editingTenant?.contactEmail,
                  contactPhone: editingTenant?.contactPhone,
                  contactAddress: editingTenant?.contactAddress,
                }}
              />
              <AddTenantRateModal
                show={tenantSubscriptionModelVisible}
                onClose={() => setTenantSubscriptionModelVisible(false)}
                tenant={selectedTenant}
              />
            </div>
          )}
          <div>
            <div className="d-flex justify-content-between align-items-center">
              <div></div>
              <div>
                <Form form={formPaginate}>
                  <Form.Item
                    name="paginate"
                    className="text-lable"
                    style={{ width: "100px" }}
                  >
                    <Select
                      className="control-Select"
                      onChange={(value) => {
                        handlesetPaginateLimit(value);
                      }}
                      options={[
                        { value: 10, label: "10" },
                        { value: 20, label: "20" },
                        { value: 30, label: "30" },
                        { value: 40, label: "40" },
                        { value: 50, label: "50" },
                      ]}
                    />
                  </Form.Item>
                </Form>
              </div>
            </div>
            {/* <div className="tenant-cards">
              {renderCards()}
            </div> */}

            <table className="table Tenants-table">
              <thead>
                <tr>
                  <th>Code</th>
                  <th>Name</th>
                  <th>Registered Date</th>
                  <th className="text-center">Subscription Status</th>
                  <th className="text-center">Has Multiple Shops</th>
                  <th className="text-center"></th>
                </tr>
              </thead>
              <tbody>{renderTableRows()}</tbody>
            </table>
            {paginatedData.length > 0 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              maxVisiblePages={5}
              showPageInfo={true}
              totalItems={totalElements}
              pageSize={PaginateLimit}
            />
          )}
          </div>
        </Content>
        {/* --- Render the Payment Modal once here --- */}
        <CreatePaymentModal
          show={PaymentReceiveModelVisible}
          onClose={closePaymentReceiveModal}
          // onSubmit={handlePaymentSubmit}
          tenant={selectedTenant}
        />
        <UpdateTenantRateModal
          show={UpdateTenantRateModelVisible}
          onClose={closeUpdateTenantRateModal}
          // onSubmit={handlePaymentSubmit}
          tenant={selectedTenant}
        />
        <DeleteTenantConfirmModal
          visible={deleteModalVisible}
          tenant={tenantToDelete}
          onDelete={handleDelete}
          onCancel={handleCancelDelete}
        />
        <InvoiceModal open={isInvoiceModelOpen} tenant={selectedTenant} onCancel={() => setIsInvoiceModelOpen(false)} />

        <Modal
          title={`Tenant Details - ${selectedTenantDetails?.tenantName || ''}`}
          open={tenantDetailsModalVisible}
          onCancel={closeTenantDetailsModal}
          footer={[
            <Button key="close" onClick={closeTenantDetailsModal}>
              Close
            </Button>
          ]}
          width={700}
        >
          {selectedTenantDetails && (
            <div>
              <Table
                dataSource={getTenantDetailsData(selectedTenantDetails)}
                pagination={false}
                showHeader={false}
                bordered
                size="small"
              // footer={null} 
              // maskClosable={true}
              // mask={true} 
              >
                <Table.Column
                  title="Field"
                  dataIndex="field"
                  key="field"
                  render={(text) => <strong>{text}</strong>}
                  width="40%"
                />
                <Table.Column
                  title="Value"
                  dataIndex="value"
                  key="value"
                  width="60%"
                />
              </Table>

              {/* Additional styling for better presentation */}
              <style jsx>{`
                :global(.ant-table-tbody > tr > td) {
                  padding: 8px 12px;
                }
                :global(.ant-table-tbody > tr > td:first-child) {
                  background-color: #fafafa;
                  border-right: 1px solid #f0f0f0;
                }
              `}</style>
            </div>
          )}
        </Modal>

        <CurrencySetModal
          tenant={selectedTenant}
          open={tenantCurrencyModalVisible}
          onClose={() => setTenantCurrencyModalVisible(false)}
        />

        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};

export default Tenants;
